// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ebyf","field":"styles_field__1WRNt","fieldCol":"styles_fieldCol__2-Rlv","diffCol":"styles_diffCol__2r-1Q","diff":"styles_diff__2jmPJ"};